/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Wakil_S1Inputs */

const en_tut_wakil_s1 = /** @type {(inputs: Tut_Wakil_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open the presence popover and flip the **Wakil Digital** switch, or go into **Pengaturan…** for the details.`)
};

const id_tut_wakil_s1 = /** @type {(inputs: Tut_Wakil_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buka popover presence, nyalakan sakelar **Wakil Digital**, atau masuk ke **Pengaturan…** untuk mengaturnya lebih rinci.`)
};

/**
* | output |
* | --- |
* | "Open the presence popover and flip the **Wakil Digital** switch, or go into **Pengaturan…** for the details." |
*
* @param {Tut_Wakil_S1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_wakil_s1 = /** @type {((inputs?: Tut_Wakil_S1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Wakil_S1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_wakil_s1(inputs)
	return en_tut_wakil_s1(inputs)
});